import React from 'react';

const NotFound = (): JSX.Element => {
    return (
        <div>Not Found</div>
    )
}

export default NotFound;